import { render, staticRenderFns } from "./InsuranceIndemnity.vue?vue&type=template&id=9a970d36&scoped=true"
import script from "./InsuranceIndemnity.vue?vue&type=script&lang=js"
export * from "./InsuranceIndemnity.vue?vue&type=script&lang=js"
import style0 from "./InsuranceIndemnity.vue?vue&type=style&index=0&id=9a970d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a970d36",
  null
  
)

export default component.exports